import { render, staticRenderFns } from "./BrandContent.vue?vue&type=template&id=b40bf73c&scoped=true&"
import script from "./BrandContent.vue?vue&type=script&lang=js&"
export * from "./BrandContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40bf73c",
  null
  
)

export default component.exports